






















 import { Component, Vue } from 'vue-property-decorator'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalMenu from '@/components/GlobalMenu'
 @Component({
   name:'BasicLayout',
   components: {
     GlobalHeader,
     GlobalMenu
   }
 })
 export default class BasicLayout extends Vue {
 }
